import { useSite } from "./use-site";
import { useEnv } from "./use-env";
export var useTermsPagePath = function () {
  var _a;
  var site = useSite();
  var env = useEnv();
  return env.TERMS_PATH || ((_a = site === null || site === void 0 ? void 0 : site.termsPage) === null || _a === void 0 ? void 0 : _a.path) || '';
};